import LOGO_DARK from './logo-dark.png'
import LOGO_LIGHT from './logo-light.png'
import CHATVIA_LOGO_SVG from '../../../logo.svg'

const LOGO = { DARK: LOGO_DARK, LIGHT: LOGO_LIGHT, SVG: CHATVIA_LOGO_SVG }

export default LOGO
